export default {
    url: '/events/add',
    template: '<events-add courses="vm.courses" event="vm.event"></events-add>',
    resolve: {
        event: (EventResource) => {
            return new EventResource();
        }
    },
    controller ($scope, event) {
        this.event = event;
        this.sites = $scope.$parent.vm.sites;
        this.courses = $scope.$parent.vm.courses;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/events/add/index.js